var _a;
/*
 * List of string constants to represent different props
 */


var LOADING = "loading";
var COLOR = "color";
var CSS = "css";
var SIZE = "size";
var SIZE_UNIT = "sizeUnit";
var WIDTH = "width";
var WIDTH_UNIT = "widthUnit";
var HEIGHT = "height";
var HEIGHT_UNIT = "heightUnit";
var RADIUS = "radius";
var RADIUS_UNIT = "radiusUnit";
var MARGIN = "margin";
/*
 * Array for onlyUpdateForKeys function
 */

var commonStrings = [LOADING, COLOR, CSS];
var sizeStrings = [SIZE, SIZE_UNIT];
var heightWidthString = [HEIGHT, HEIGHT_UNIT, WIDTH, WIDTH_UNIT];
export var sizeKeys = commonStrings.concat(sizeStrings);
export var sizeMarginKeys = sizeKeys.concat([MARGIN]);
export var heightWidthKeys = commonStrings.concat(heightWidthString);
export var heightWidthRadiusKeys = heightWidthKeys.concat([RADIUS, RADIUS_UNIT, MARGIN]);
var commonValues = (_a = {}, _a[LOADING] = true, _a[COLOR] = "#000000", _a[CSS] = {}, _a);

var heightWidthValues = function heightWidthValues(height, width) {
  var _a;

  return _a = {}, _a[HEIGHT] = height, _a[HEIGHT_UNIT] = "px", _a[WIDTH] = width, _a[WIDTH_UNIT] = "px", _a;
};

var sizeValues = function sizeValues(sizeValue) {
  var _a;

  return _a = {}, _a[SIZE] = sizeValue, _a[SIZE_UNIT] = "px", _a;
};

export var sizeDefaults = function sizeDefaults(sizeValue) {
  return Object.assign({}, commonValues, sizeValues(sizeValue));
};
export var sizeMarginDefaults = function sizeMarginDefaults(sizeValue) {
  var _a;

  return Object.assign({}, sizeDefaults(sizeValue), (_a = {}, _a[MARGIN] = "2px", _a));
};
export var heightWidthDefaults = function heightWidthDefaults(height, width) {
  return Object.assign({}, commonValues, heightWidthValues(height, width));
};
export var heightWidthRadiusDefaults = function heightWidthRadiusDefaults(height, width, radius) {
  var _a;

  if (radius === void 0) {
    radius = 2;
  }

  return Object.assign({}, heightWidthDefaults(height, width), (_a = {}, _a[RADIUS] = radius, _a[RADIUS_UNIT] = "px", _a[MARGIN] = "2px", _a));
};